import { ModalRoute } from "../../Navigation/ModalRoute";
import { ModalTransitionSwitch } from "../../Navigation/ModalTransitionSwitch";
import { AddLicenseAddQualificationBottomSheet } from "./AddQualificationBottomSheet";
import { AddLicenseAddStateBottomSheet } from "./AddStateBottomSheet";
import { AddLicenseDuplicateBottomSheet } from "./DuplicateBottomSheet";
import { AddLicenseErrorBottomSheet } from "./ErrorBottomSheet";
import { AddLicenseInReviewBottomSheet } from "./InReviewBottomSheet";
import {
  ADD_QUALIFICATION_MODAL_PATH,
  ADD_STATE_MODAL_PATH,
  LICENSE_DUPLICATE_MODAL_PATH,
  LICENSE_ERROR_MODAL_PATH,
  LICENSE_IN_REVIEW_MODAL_PATH,
  SUBMITTING_LICENSE_MODAL_PATH,
} from "./paths";
import { SubmittingLicenseBottomSheet } from "./SubmittingLicenseBottomSheet";

interface AddLicenseModalRoutesProps {
  basePath: string;
  roleDetailsPath: string;
  qualificationId: string;
  addLicensePath: string;
}

export function AddLicenseModalRoutes(props: AddLicenseModalRoutesProps) {
  const { basePath, roleDetailsPath, qualificationId, addLicensePath } = props;

  return (
    <ModalTransitionSwitch>
      <ModalRoute
        shouldReplacePathOnBack
        closeModalPath={basePath}
        path={`${basePath}/${ADD_STATE_MODAL_PATH}`}
        render={({ modalState }) => {
          return <AddLicenseAddStateBottomSheet modalState={modalState} />;
        }}
      />

      <ModalRoute
        shouldReplacePathOnBack
        closeModalPath={basePath}
        path={`${basePath}/${SUBMITTING_LICENSE_MODAL_PATH}`}
        render={({ modalState }) => {
          return <SubmittingLicenseBottomSheet modalState={modalState} />;
        }}
      />

      <ModalRoute
        shouldReplacePathOnBack
        closeModalPath={basePath}
        path={`${basePath}/${LICENSE_IN_REVIEW_MODAL_PATH}`}
        render={({ modalState }) => {
          return (
            <AddLicenseInReviewBottomSheet
              modalState={modalState}
              roleDetailsPath={roleDetailsPath}
              qualificationId={qualificationId}
            />
          );
        }}
      />

      <ModalRoute
        shouldReplacePathOnBack
        closeModalPath={basePath}
        path={`${basePath}/${ADD_QUALIFICATION_MODAL_PATH}`}
        render={({ modalState }) => {
          return (
            <AddLicenseAddQualificationBottomSheet
              modalState={modalState}
              addLicensePath={addLicensePath}
            />
          );
        }}
      />

      <ModalRoute
        shouldReplacePathOnBack
        closeModalPath={basePath}
        path={`${basePath}/${LICENSE_DUPLICATE_MODAL_PATH}`}
        render={({ modalState }) => {
          return (
            <AddLicenseDuplicateBottomSheet
              modalState={modalState}
              roleDetailsPath={roleDetailsPath}
              qualificationId={qualificationId}
            />
          );
        }}
      />

      <ModalRoute
        shouldReplacePathOnBack
        closeModalPath={basePath}
        path={`${basePath}/${LICENSE_ERROR_MODAL_PATH}`}
        render={({ modalState }) => {
          return (
            <AddLicenseErrorBottomSheet
              modalState={modalState}
              roleDetailsPath={roleDetailsPath}
              qualificationId={qualificationId}
            />
          );
        }}
      />
    </ModalTransitionSwitch>
  );
}
